import { PARTNERS_CONFIG } from "../constants/config"
import { type PartnerKey } from "../types/partnerKey"

export function getPartnerConfig(partner: PartnerKey | null) {
    return PARTNERS_CONFIG[partner ?? "default"]
}
